var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "badge-list" }, [
    _c("div", { staticClass: "badge-list-box" }, [
      _vm.metals.length > 0
        ? _c(
            "ul",
            { staticClass: "badge-list" },
            _vm._l(_vm.metals, function (item, index) {
              return _c("li", { key: index }, [
                _c("div", { staticClass: "badge_item" }, [
                  _c("img", {
                    staticClass: "badge_icon",
                    attrs: { src: _vm.$imgfilter(item.icon) },
                  }),
                  _c("div", { staticClass: "badge_name" }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "btn-recharge badge_btn",
                      class: _vm.user.currMetalUrl == item.icon ? "gary" : "",
                      on: {
                        click: function ($event) {
                          return _vm.onChangeMetal(item)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.user.currMetalUrl == item.icon ? "卸下" : "装备"
                          )
                        ),
                      ]),
                    ]
                  ),
                ]),
              ])
            }),
            0
          )
        : _c("div", { staticClass: "none-item" }, [
            _c("img", {
              attrs: { src: require("@/assets/images/none-item.svg"), alt: "" },
            }),
            _c("div", [_vm._v("暂无数据")]),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }